import styled from 'styled-components';
import { Button } from '@bynder/design-system';

export const AddAssetButton = styled(Button)`
    width: 100%;
    height: 100%;

    font-size: 14px;
`;
